import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyD_Dw4eCHecsN_cxYOJkcC6uVpGJTIrTz0",
    authDomain: "slack-clone-5590f.firebaseapp.com",
    projectId: "slack-clone-5590f",
    storageBucket: "slack-clone-5590f.appspot.com",
    messagingSenderId: "487597659531",
    appId: "1:487597659531:web:f89982adc7834773328b8e",
    measurementId: "G-XG8B10B3ED"
  };
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider()
  
export {auth, provider}
export default db;